export default "__VITE_ASSET__DZCLQS8N__"